import classNames from "classnames";
import { DeleteNotesButton } from "@/entities/delete-notes-button";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  isShowHeader?: boolean;
  headerTitle?: string;
  onDeleteButtonClick?: () => void;
  disabledButton?: boolean;
  contactsPage?: boolean;
};

export const NotesManagerHeader: FC<Props> = ({
  isShowHeader = true,
  headerTitle,
  disabledButton,
  onDeleteButtonClick = () => "",
  contactsPage = false,
}) => {
  if (!isShowHeader) return <></>;
  return (
    <div className={classNames(styles.root, { [styles["root--contacts"]]: contactsPage })}>
      {!contactsPage && <div className={styles.title}>{headerTitle}</div>}
      <div>
        <DeleteNotesButton
          disabled={disabledButton}
          onClick={onDeleteButtonClick}
          contactsPage={contactsPage}
        />
      </div>
    </div>
  );
};
